<template>
  <picture>
    <source srcset="/img/logo-f-21x33.png.webp" type="image/webp" />
    <source srcset="/img/logo-f-21x33.png" type="image/png" />
    <img
      src="/img/logo-f-21x33.png"
      alt="FlixLatino Logo"
      width="21"
      :height="logoHeight"
      class="img-fluid"
      style="margin: 0.5em"
    />
  </picture>
</template>
<script>
export default {
  name: "LogoF",
  props: {
    logoHeight: {
      type: String,
      default: "33",
    },
  },
};
</script>